import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceInTranslationPipe } from './replace-in-translation.pipe';

@NgModule({
  declarations: [ReplaceInTranslationPipe],
  imports: [CommonModule],
  exports: [ReplaceInTranslationPipe],
  providers: [],
})
export class TranslationModule {}
